<template>
  <div class="feedback_body">
  <el-button style="float:right" type="warning" icon="el-icon-message" size="small"  @click="openFeedBackDialog()">提交反馈</el-button>
    <p style="font-size: 14px;color: #5e6d82;">仅展示最近100条数据</p>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%; margin-bottom:40px"
      max-height='655px'
      :row-style="tableRowStyle"
      :header-cell-style="tableHeaderColor"
      :cell-style="tableCellStyle"
    >
      <el-table-column label="反馈类型">
        <template slot-scope="scope">
          <el-tag size="medium">{{scope.row.tid_text}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="投诉内容" width="600">
        <template slot-scope="scope">
          <el-popover trigger="click" placement="top">
            <el-descriptions title="详细内容" border style="width:900px" :column=2>
                <el-descriptions-item label="玩家" label-class-name="feedback_label">{{scope.row.nikename}}</el-descriptions-item>
                <!-- <el-descriptions-item label="渠道" label-class-name="feedback_label">{{scope.row.chann}}</el-descriptions-item> -->
                <el-descriptions-item label="创建时间" label-class-name="feedback_label">{{scope.row.create_time}}</el-descriptions-item>
                <el-descriptions-item label="反馈描述" label-class-name="feedback_label" span=3>{{scope.row.msg}}</el-descriptions-item>
                <el-descriptions-item label="客服回复" label-class-name="feedback_label" span=3>{{scope.row.replycont}}</el-descriptions-item>
            </el-descriptions>
            <div slot="reference" class="name-wrapper">
              <el-tag class="feedback_msg" size="medium" effect="dark" type="danger">{{ scope.row.msg }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="nikename" label="玩家昵称"></el-table-column>
      <el-table-column prop="create_time" label="创建时间"></el-table-column>
      <el-table-column prop="status" width="150" label="状态" >
        <template slot-scope="scope">
          <el-tag size="medium" effect="dark" type="success">已解决</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <feedback-form ref="feedbackForm"></feedback-form>
    <pagination v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getPlayerFeedbackLists" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import FeedbackForm from './FeedbackForm'
import {getFeedbackList} from '@/api/common'

export default {
  components: {
    Pagination,
    FeedbackForm
  },
  data () {
    return {
      listLoading: true,
      total: 0,
      list: [],
      listQuery: {
        page: 1,
        limit: 10
      }
    }
  },
  methods: {
    openFeedBackDialog () {
      this.$refs.feedbackForm.isShowDialog = true
    },
    handleCurrentChange (current) {
      this.params.page = current
    },
    getPlayerFeedbackLists () {
      var params = {
        isShow: 1,
        page: this.listQuery.page,
        size: this.listQuery.limit
      }
      getFeedbackList(params).then(response => {
        const res = response.data
        if (res.code === 0) {
          this.list = res.data.list
          this.total = res.data.total
          this.listLoading = false
        }
      })
    },
    tableRowStyle ({row, rowIndex}) {
      return {
        'font-size': '14px'
      }
    },
    tableCellStyle ({row, column, rowIndex, columnIndex}) {
      return {
        'text-align': 'center'
      }
    },
    tableHeaderColor ({row, column, rowIndex, columnIndex}) {
      return {
        'font-wight': '500',
        'font-size': '16px',
        'padding': '15px 0',
        'text-align': 'center'
        // 'color': '#000'
      }
    }
  },
  created () {
    this.getPlayerFeedbackLists()
  }
}
</script>

<style>
.feedback_body{
  width: 100%;
  min-height: 500px;
}

.feedback_label {
  width: 80px;
  background: #E1F3D8;
}
.feedback_msg {
    max-width: 400px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/views/service_center/children/PlayerFeedback.vue